<template>
	<div>
		<b-navbar toggleable="lg" type="dark" class="customNavHeader"  :style="cssVars">
			<b-navbar-nav>
				<span>{{headerTitle}}</span>
			</b-navbar-nav>

<!--			<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

			<b-collapse id="nav-collapse" is-nav>
			
				<b-navbar-nav class="ml-auto sgHeaderText">
					<b-nav-item href="http://localhost/scanandget/public_html/qr-admin/dashboard.php" right>
						Dashboard
					</b-nav-item>
					<b-nav-item to="manageOrders">
						View Orders
					</b-nav-item>
					<b-nav-item to="adminSlots">
						Manage Slots
					</b-nav-item>
					<b-nav-item-dropdown to="ccsettings" text="Settings" right>						
							<b-dropdown-item to="configureSlots">Configure Slots</b-dropdown-item>
							<b-dropdown-item to="ccsettings">Click&Collect Settings</b-dropdown-item>
					</b-nav-item-dropdown>
				</b-navbar-nav>
			</b-collapse>-->
		</b-navbar>
	</div>
</template>
<script>
export default{
	name: 'CustomerNavHeader',
	props: ['headerTitle', 'customCSS'],
	data() {
		return {

		}
	},
	computed: {
		cssVars() {
			return {
			'--bg-color': this.customCSS.bgColor,
			'--font-color': this.customCSS.fontColor
			}
		}
	}
}
</script>
<style scoped>
	.sgHeaderText, .sgHeaderText a{
		color: #fff
	}
	
	.customNavHeader{
		background-color: var(--bg-color);
		color: var(--font-color);
	}
	
</style>
